import { useNavigate } from "react-router-dom";
import LockSVG from "../../content/img/lock.svg";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@etframework/ui.components";

export const Unauthorized = () => {
  const { t } = useTranslation(["errorPages"]);
  const navigate = useNavigate();

  return (
    <>
      <div className="error-page-container">
        <img
          src={LockSVG}
          alt="Error illustration"
          className="error-image unauthorized"
          style={{ width: "130px" }}
        />
        <h1 className="error-title">
          {t("Unauthorized.title")}
        </h1>
        <p className="error-message">
          <Trans i18nKey="errorPages:Unauthorized.message" />
        </p>
        <div className="mt-4">
          <Button
            onClick={() => navigate("/")}
          >
            {t("HomeBtn")}
          </Button>
        </div>
      </div>
    </>
  );
};
